var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulgarianFlagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.846,
    height: 37.848,
    viewBox: "0 0 37.846 37.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1722",
    x: 0,
    y: 0,
    width: 37.846,
    height: 37.848,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bulgarian-flag-icon",
    transform: "translate(9 -3.15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 3.15)",
    filter: "url(#Ellipse_1722)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1722-2",
    "data-name": "Ellipse 1722",
    cx: 9.923,
    cy: 9.924,
    rx: 9.923,
    ry: 9.924,
    transform: "translate(9 6)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bulgaria",
    transform: "translate(-0.298 9.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33195",
    "data-name": "Path 33195",
    d: "M20,159.739a9.977,9.977,0,0,0-.622-3.478L10,155.826l-9.378.435a10.036,10.036,0,0,0,0,6.957l9.378.435,9.378-.435A9.978,9.978,0,0,0,20,159.739Z",
    transform: "translate(0 -149.739)",
    fill: "#496e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33196",
    "data-name": "Path 33196",
    d: "M25.3,351.565a10,10,0,0,0,9.378-6.522H15.923A10,10,0,0,0,25.3,351.565Z",
    transform: "translate(-15.301 -331.565)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33197",
    "data-name": "Path 33197",
    d: "M15.923,6.522H34.679a10,10,0,0,0-18.756,0Z",
    transform: "translate(-15.301)",
    fill: "#f0f0f0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulgarianFlagIcon);
export default __webpack_public_path__ + "static/media/bulgarian-flag-icon.6bf7019a6e0cd5ad32d5d71bdadef1df.svg";
export { ForwardRef as ReactComponent };